import React, { type HTMLAttributes, type ReactElement } from "react";
import { twMerge } from "tailwind-merge";

import { messages } from "@/globals.content";
import { TYPO_STYLES } from "@/styles/typography";

type ProductKlassenstufenProps = {
    klassenstufen: string[];
    lernjahre: string[] | undefined;
};
export const ProductKlassenstufenView = ({
    lernjahre,
    klassenstufen,
    className,
}: ProductKlassenstufenProps & HTMLAttributes<HTMLDivElement>): ReactElement => {
    return (
        <div className={twMerge("leading-6 flex gap-3 items-start", className)}>
            <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                {String.fromCharCode(Number("0xe93c"))}
            </span>
            <p className={twMerge(TYPO_STYLES.bodyNormal16(), "text-brandDark")}>
                {lernjahre && lernjahre.length > 0
                    ? lernjahreToString(lernjahre)
                    : klassenstufenToString(klassenstufen)}
            </p>
        </div>
    );
};

function klassenstufenToString(klassenstufen: string[]): string {
    const numberValues = klassenstufen
        .filter((level) => !isNaN(Number(level)))
        .sort((a, b) => Number(a) - Number(b));
    const textValues = klassenstufen.filter((level) => isNaN(Number(level)));

    const numberString =
        numberValues.length > 0 ? `${numberValues.join(". | ")}. ${messages.meta.klasse}` : "";
    const textString = textValues.join(" | ");

    return [numberString, textString].filter(Boolean).join(" | ");
}

function lernjahreToString(lernjahre: string[]): string {
    const sortedLernjahre = lernjahre.sort((a, b) => Number(a) - Number(b));
    return `${sortedLernjahre.join(". | ")}. ${messages.meta.lernjahr}`;
}
